<script>
let vm = null;
import { DayPilot, DayPilotScheduler } from "daypilot-pro-vue";
import moment from "moment";
import Drawer from "@/components/drawer";
import { reactive, ref } from "vue";
import DatePicker from "vue2-datepicker";

// Custom Components
import BookingDetails from "@/components/booking-details.vue";
import BookingForm from "@/components/BookingForm/BookingForm.vue";

import BookingService from "@/helpers/APIService/booking.service";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";

export default {
  name: "Scheduler",
  setup() {
    const scheduler = ref(null);
    const config = reactive({
      timeHeaders: [{ groupBy: "Month" }, { groupBy: "Day", format: "d" }],
      scale: "Day",
      days: 30,
      startDate: DayPilot.Date.today(),
      timeRangeSelectedHandling: "Enabled",
      cornerHtml: `<div style='padding: 5px;font-size: 14px;text-align: center;font-weight: 500'>Rooms</div>`,
      treeEnabled: true,
      eventHeight: 35,
      cellMarginBottom: 10,
      cellWidth: "Auto",
      cellWidthSpec: "Auto",
      cellWidthMin: 60,
      visible: true,
      dynamicLoading: true,
      HeightSpec: "full",
      Scrollbar: "hidden",
      height: 1000,
      theme: "scheduler_white",
      useEventBoxes: "Never",
      snapToGrid: false,
      oadingLabelVisible: true,
      onScroll: (args) => {
        args.async = true;
        args.events = vm ? vm.config.events : "";
        args.loaded();
      },
      onBeforeRowHeaderRender: function (args) {
        args.row.cssClass = "header";
      },
      onBeforeEventRender: function (args) {
        args.data.deleteDisabled = true;
        args.data.cssClass = "event";
        args.data.html = `<div class="text-truncate font-size-12"> ${
          args.e.guestName
        } </div><div class="avatar-xs" ><span class="avatar-title bg-soft bg-primary text-secondary font-20 rounded-circle">${args.e.booking_source.name.charAt(
          0
        )}</span></div>`;
      },
      onBeforeCellRender: function (args) {
        if (args.cell.start == DayPilot.Date.today()) {
          args.cell.backColor = "#50a5f12e";
        }
        if (args.cell.isParent) {
          args.cell.areas = [
            {
              text: "",
            },
          ];
          args.cell.cssClass = "cellRender";
        }
      },
      onTimeRangeSelected: async (args) => {
        const startDate = new Date(args.start.value);
        if (
          moment(startDate).format("YYYY MM DD") >=
          moment().format("YYYY MM DD")
        ) {
          this.newBookingData = {
            room_type: args.resource,
            start_date: args.start.value,
            end_date: args.end.value,
          };
          this.newBookingForm();
        } else {
          Middleware.notification(
            "Can't book room on before current date !!",
            "warning",
            3000
          );
        }
      },
      eventClickHandling: "Update",
      onEventClick: function (args) {
        vm.openBookingDetails(args.e.cache);
      },
      eventMoveHandling: "Update",
      onEventMoved: (args) => {
        const response = vm.editRoom();
        // if (response) {
        vm.booking = { ...vm.booking, ...args.e.cache };
        // } else {
        //   args.left.enabled = false;
        //   args.right.html = "You can't move an event from different room type.";
        //   args.allowed = false;
        // }
      },
      onEventMoving: (args) => {
        if (
          scheduler.value.control.rows.find(args.resource).parent() !== null
        ) {
          if (
            scheduler.value.control.rows.find(args.resource).parent().id !==
            scheduler.value.control.rows.find(args.e.resource()).parent().id
          ) {
            args.left.enabled = false;
            args.right.html = "You can't move room.";
            args.allowed = false;
          } else {
            vm.booking = {
              ...vm.booking,
              room_type: scheduler.value.control.rows
                .find(args.resource)
                .parent().id,
            };
            const response = vm.editRoom();
            if (!response) {
              args.left.enabled = false;
              args.right.html = "You can't move room.";
              args.allowed = false;
            }
          }
        }
      },
      eventResizeHandling: "Update",
      onEventResized: (args) => {
        args.control.message("Event resized: " + args.e.text());
      },
      eventHoverHandling: "Bubble",
      bubble: new DayPilot.Bubble({
        onLoad: (args) => {
          if (args.source.cache.booking_source_reference_no !== undefined) {
            args.html = `<div>
              <p class="mb-0">Guest Name. : ${args.source.cache.guestName} </p>
              <p class="mb-0">Ref No. : #${args.source.cache.reference_no} </p>
               <p class="mb-0">PMS : #${args.source.cache.booking_source_reference_no} </p>
               <p class="mb-0">OTA : #${args.source.cache.ota_reference_no} </p>
               <p class="mb-0">Total Guest : ${args.source.cache.total_guest} </p>
               </div>`;
          } else {
            args.html = `<div>
              <p class="mb-0">Guest Name. : ${args.source.cache.guestName} </p>
              <p class="mb-0">Ref No. : #${args.source.cache.reference_no} </p>
              <p class="mb-0">Total Guest : ${args.source.cache.total_guest} </p>
               </div>`;
          }
        },
      }),
      resourceBubble: new DayPilot.Bubble({
        onLoad: (args) => {
          args.html = `<h1>${args.source.name}</h1>`;
        },
      }),
    });
    return {
      scheduler,
      config,
    };
  },
  data: function () {
    return {
      RoomByRoomTypeData: [],
      BookingListData: [],
      openNewBookingForm: false,
      newBookingData: {},
      selectedBooking: null,
      viewBookingDetails: false,
      countApiCall: 0,
      check_in_date: null,
      check_out_date: null,
      roomData: [],
      booking: null,
      calenderDate: [],
    };
  },
  components: {
    DayPilotScheduler,
    BookingForm,
    BookingDetails,
    Drawer,
    DatePicker,
  },
  computed: {
    scheduler: function () {
      return this.$refs.scheduler.control;
    },
    bookingDetailsProps() {
      return {
        booking: this.selectedBooking,
      };
    },
    bookingProps() {
      return {
        newBookingData: this.newBookingData,
      };
    },
  },
  mounted: function () {
    this.$root.$on("booking_table", () => {
      if (this.countApiCall < 1) {
        this.callApis();
      }
    });
  },
  methods: {
    // Method is used to Call APIs
    callApis() {
      this.calenderDate.push(moment().format("YYYY-MM-DD"));
      this.calenderDate.push(moment().add(30, "d").format("YYYY-MM-DD"));
      this.countApiCall += 1;
      vm = this;
      this.getRoomListForCalendar();
    },
    // Method is used to GET Room List by Room type
    async getRoomListForCalendar(status) {
      try {
        this.RoomByRoomTypeData = [];
        this.BookingListData = [];
        this.config.events = [];
        let today = new Date();
        if (status == undefined) {
          this.check_in_date = moment(today).format("YYYY-MM-DD");
          this.check_out_date = moment(today).add(30, "d").format("YYYY-MM-DD");
        }
        const query_str =
          "?start_date=" +
          this.check_in_date +
          "&end_date=" +
          this.check_out_date;
        const response = await UserService.getRoomListForCalendar(query_str);
        this.config.cornerHtml = `<div style='padding: 5px;font-size: 14px;text-align: center;font-weight: 500'>Total Rooms: ${response.length}</div>`;
        if (response !== null || response !== "") {
          /** LOAD RESOURCES */
          let tempArr = response.reduce((r, a) => {
            r[
              JSON.stringify({
                id: a.room_type.id,
                name: a.room_type.short_name,
                full_name: a.room_type.name,
              })
            ] = [
              ...(r[
                JSON.stringify({
                  id: a.room_type.id,
                  name: a.room_type.short_name,
                  full_name: a.room_type.name,
                })
              ] || []),
              a,
            ];
            return r;
          }, {});
          Object.keys(tempArr).map((key) => {
            const { full_name, name, id } = JSON.parse(key);
            let data = {
              id,
              name,
              full_name,
              isChildren: true,
              expanded: true,
              cellsAutoUpdated: true,
              children: tempArr[key].map((item) => {
                return {
                  name: item.room_number,
                  id: item.id,
                  full_name: "",
                  isChildren: false,
                };
              }),
            };
            this.RoomByRoomTypeData.push(data);
          });
          /** LOAD EVENTS */
          response.map((data) => {
            if (data.bookings.length !== 0) {
              data.bookings.map((item) => {
                item.check_out_date = moment(item.check_out_date)
                  .add(1, "day")
                  .format("YYYY MM DD")
                  .toString();
                let barColor = "#adcdea";
                if (
                  item.status === "new_booking" ||
                  item.status === "pre_checkin" ||
                  item.status === "reservation" ||
                  item.status === "pre_checked_done"
                ) {
                  barColor = "#adcdea";
                } else if (item.status === "checked_in") {
                  barColor = "#b7d6a3";
                } else if (
                  item.status === "cancelled" ||
                  item.status === "no_show"
                ) {
                  barColor = "#f6be98";
                } else if (item.status === "checked_out") {
                  barColor = "#ffdf7f";
                } else {
                  barColor = "#adcdea";
                }
                let obj = {
                  id: item.id,
                  start: moment(item.check_in_date)
                    .add(12, "hours")
                    .toISOString(),
                  end: moment(item.check_out_date)
                    .subtract(6, "hours")
                    .toISOString(),
                  resource: data.id,
                  image: item.primary_guest.selfie_image,
                  guestName:
                    item.primary_guest.first_name +
                    " " +
                    item.primary_guest.last_name,
                  backColor: barColor,
                  moveVDisabled: true,
                  moveHDisabled: true,
                  resizeDisabled: true,
                  allotted_room: {
                    floor: data.floor,
                    hotel: data.hotel,
                    is_accessible: data.is_accessible,
                    is_pet_friendly: data.is_pet_friendly,
                    is_smoking: data.is_smoking,
                    lock_iot_device: data.lock_iot_device,
                    occupancy_status: data.occupancy_status,
                    room_number: data.room_number,
                    connect_room_number: data.connect_room_number,
                  },
                  barHidden: true,
                  ...item,
                };
                this.BookingListData.push(obj);
              });
            }
          });
          this.loadResources();
          this.loadEvents();
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to load events
    loadEvents() {
      const events = this.BookingListData;
      this.config.events = events;
    },
    // Method is used to load resources
    loadResources() {
      const resources = this.RoomByRoomTypeData;
      this.config.resources = resources;
    },
    // Method is used to open booking form
    newBookingForm() {
      this.openNewBookingForm = !this.openNewBookingForm;
    },
    // Method is used to open booking details
    openBookingDetails(data = null) {
      if (data != null) {
        this.selectedBooking = data;
      }
      this.viewBookingDetails = !this.viewBookingDetails;
    },
    // Method is used to add and update booking
    bookingAddedUpdated(data) {
      data = { ...data, ago: "0 day" };
      this.table.tableData.unshift(data);
      this.newBookingForm();
      Middleware.notification("Booking created successfully !!", "success");
    },
    // Method is used to update room
    editRoom() {
      let isRoomAvl = false;
      const filterData =
        "?check_in_date=" +
        moment(this.booking.check_in_date).format("YYYY-MM-DD") +
        "&check_out_date=" +
        moment(this.booking.check_out_date).format("YYYY-MM-DD") +
        "&room_type=" +
        this.booking.room_type +
        "&occupancy_status=v" +
        "&hk_status=c";
      BookingService.getRoomNoAvailabilityByRoomType(filterData)
        .then((roomData) => {
          if (roomData.length !== 0) {
            // this.$bvModal.show("open-room-modal");
            this.roomData = roomData;
            isRoomAvl = true;
          } else {
            Middleware.notification("No rooms available !!", "danger", 3000);
            // this.$bvModal.hide("open-room-modal");
            isRoomAvl = false;
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
      return isRoomAvl;
    },
    // Method is used to check date change
    changeDate() {
      this.config.startDate = this.calenderDate[0];
      const diff = moment(this.calenderDate[0]).diff(
        moment(this.calenderDate[1]),
        "days"
      );
      this.config.days = Math.abs(diff) + 1;
    },
  },
};
</script>
<template>
  <div>
    <div class="row mb-2">
      <div class="col-md-2">
        <date-picker
          v-model="calenderDate"
          type="date"
          range
          placeholder="Select date range"
          :clearable="false"
          @change="changeDate"
          value-type="format"
        ></date-picker>
      </div>
    </div>
    <DayPilotScheduler id="dp" :config="config" ref="scheduler" class="h-100" />
    <!-- New booking form drawer -->
    <Drawer
      @close="newBookingForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :maxWidth="1075"
      :zIndex="1002"
    >
      <div v-if="openNewBookingForm">
        <BookingForm
          :currentProps="bookingProps"
          @submitted="bookingAddedUpdated"
          @cancelSubmit="newBookingForm"
        />
      </div>
    </Drawer>
    <!-- Method is use for open drawer -->
    <Drawer
      @close="openBookingDetails"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1240"
      class="w-100"
    >
      <div v-if="viewBookingDetails">
        <BookingDetails :currentProps="bookingDetailsProps" />
      </div>
    </Drawer>
    <!-- Open edit room and status -->
    <!-- <b-modal
      id="open-room-modal"
      centered
      hide-footer
      size="sm"
      title="Move Booking Over Room"
    >
      <div class="d-flex align-items-center justify-content-around mb-3">
        <h5 v-if="booking && booking.allotted_room" class="mb-0">
          {{ booking.allotted_room.room_number }}
        </h5>
        <i class="fas fa-exchange-alt"></i>
        <h5 v-if="booking && booking.allotted_room" class="mb-0">
          {{ booking.allotted_room.room_number }}
        </h5>
      </div>
      <b-button variant="success" class="d-block mx-auto">Move</b-button>
    </b-modal> -->
  </div>
</template>
<style>
.scheduler_default_corner_inner {
  display: flex;
  align-items: center;
  justify-content: center;
}
.bs-avatar {
  width: 26px;
  height: 26px;
  object-fit: cover;
}
.cellRender {
  display: flex;
  align-items: center;
  justify-content: center;
}
@import "../assets/themes/scheduler_white.css";
</style>
